"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialTargetsShiftTop = void 0;
var getFromMap_1 = require("./getFromMap");
// o -> siblings
// p -> Partners
// x -> node
// if  000xpp oooxpp ooxPP
// THE Os and Ps should not be counted!
//because parent will center itself on the REAL children
var getInitialTargetsShiftTop = function (source, targets, settings, map) {
    return (targets.reduce(function (totalHeight, target, index) {
        //for the first child, we don't care about the padding (siblings) left
        if (index !== 0) {
            var siblings = getFromMap_1.getFromMap(target[settings.nextBeforeAccessor], map);
            siblings === null || siblings === void 0 ? void 0 : siblings.forEach(function (node) {
                totalHeight += node.height + node.marginBottom;
            });
        }
        //do not add margin from last target
        totalHeight +=
            target.height +
                (index === targets.length - 1 ? 0 : target.marginBottom);
        if (index !== targets.length - 1) {
            var partners = getFromMap_1.getFromMap(target[settings.nextAfterAccessor], map);
            partners === null || partners === void 0 ? void 0 : partners.forEach(function (partner) {
                totalHeight += partner.height + partner.marginBottom;
            });
        }
        return totalHeight;
    }, 0) /
        2 -
        source.height / 2);
};
exports.getInitialTargetsShiftTop = getInitialTargetsShiftTop;
//# sourceMappingURL=getInitialTargetsShiftTop.js.map